<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <logo />
          <h2 class="brand-text text-primary ml-1">
            E-FARM
          </h2>
        </b-link>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
          
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login"
            style="padding:2em"
          >

            <!-- phone -->
            <b-form-group
              label-for="phone"
              label="로그인 아이디"
            >
              <validation-provider
                #default="{ errors }"
                name="로그인 아이디"
                rules="required"
              >
                <b-form-input
                  id="phone"
                  v-model="userId"
                  name="login-id"
                  :state="errors.length > 0 ? false:null"
                  autofocus
                  type="tel"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group
              label-for="password"
              label="비밀번호"
            >
              <validation-provider
                #default="{ errors }"
                name="비밀번호"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="******"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <div class="divider my-2" />

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              로그인
            </b-button>
          </b-form>
        </validation-observer>

        <div class="divider my-2">
          <div class="divider-text">
            or
          </div>
        </div>
        <b-card-text class="text-center mt-2"> - 회원가입은 담당자에게 문의해주세요 - </b-card-text>
        <!-- <b-card-text class="text-center mt-2">
          <b-button
            variant="secondary"
            block
            :to="{name:'auth-register'}"
          >
            회원가입
          </b-button>
        </b-card-text> -->
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt.js'
import { deviceToken } from '@/services/messaging'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardText, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/forms'
import router from '@/router'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import ability from '@/libs/acl/ability'

export default {
  components: {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    Logo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    // BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userId: '',
      password: '',
      status: '',
      // validation rules
      required,
    }
  },
  watch: {
    userId () {
      if(this.userId.length > 8) {
        this.userId = this.userId.toString().substring(0,7)
      }
    }
  },
  computed: {
    
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeOffIcon' : 'EyeIcon'
    },
  },
  methods: {
    async login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          
          const payload = {
            phone: this.userId,
            password: this.password,
          }
            // password: bcrypt.hashSync(payload.password, bcrypt.genSaltSync(10)),
          useJwt.login(payload).then(response => {
            const { userData } = response.data
            swingLoginPlugin.doLoginForce(this.userId, this.userId)
            useJwt.setToken(response.data.accessToken)
            useJwt.setRefreshToken(response.data.refreshToken)

            localStorage.setItem('userData', JSON.stringify(userData))
            ability.update(userData.ability)

            const params = {
              token: deviceToken.value,
            }

            this.$store.dispatch('users/addDeviceToken', { id: userData.id, queryBody: params })
            .then(res => {
              localStorage.setItem('deviceToken', deviceToken.value) 
            })
            router.push(getHomeRouteForLoggedInUser())
          }).catch(err => {
            //console.log(err)
            //if(window.navigator.userAgent.toLowerCase().indexOf('iphone') > -1) alert('Sorry we are developing an iphone version. Not supported')
            this.$bvModal
              .msgBoxOk('사용자 정보를 다시 입력하세요', {
                title: '로그인 실패',
                size: 'sm',
                hideHeaderClose: true,
                centered: true,
              })
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
